import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import regulaminPl from "../content/regulaminPl";
import "./LegalPage.css";

function TermsOfService() {
  const { locale } = useI18n();

  if (locale === "pl") {
    const sections = regulaminPl
      .split(/\n+/)
      .map((section) => section.trim())
      .filter(Boolean);

    return (
      <div className="legal-page">
        <div className="legal-card">
          <Link to="/register" className="legal-back-link">
            ← Powrót do rejestracji
          </Link>

          <h1>Regulamin tajnemysli.com</h1>

          <p className="legal-version">
            Aktualna wersja: 2026-08-28
          </p>

          {sections.slice(1).map((section, index) => (
            <section key={`${index}-${section.slice(0, 24)}`}>
              <p>{section}</p>
            </section>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="legal-page">
      <div className="legal-card">
        <Link to="/register" className="legal-back-link">
          ← Back to registration
        </Link>

        <h1>Terms of Service</h1>

        <p className="legal-version">
          Current version: 2026-08-28
        </p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to TajneMysli. These Terms of Service describe the rules and
            conditions that apply when you create an account, access, or use our
            entertainment and educational communication platform. By creating an
            account or using the service, you agree to follow these Terms of
            Service and our Service Rules.
          </p>
        </section>

        <section>
          <h2>2. Educational and Entertainment Purpose</h2>
          <p>
            TajneMysli is an educational and entertainment portal designed to help
            adult users practice communication, explore conversations, improve
            social interaction skills, and enjoy game-like matching and chat
            features. The service is not intended to provide professional,
            medical, psychological, legal, financial, or relationship advice.
            Any information, messages, suggestions, or conversations on the
            platform are for entertainment and educational purposes only.
          </p>
        </section>

        <section>
          <h2>3. Age Requirement</h2>
          <p>
            The service is available only to users who are 18 years of age or
            older. By registering, creating an account, or using TajneMysli, you
            confirm that you are at least 18 years old. If you are under 18, you
            must not use this service. We may suspend or remove accounts if we
            believe that a user does not meet the age requirement.
          </p>
        </section>

        <section>
          <h2>4. Account Registration</h2>
          <p>
            To use certain features of the service, you may need to create an
            account. You agree to provide accurate information during
            registration, including your email, nickname, age, gender, country,
            city, and profile information. You are responsible for maintaining
            the confidentiality of your login credentials and for all activity
            that occurs under your account.
          </p>
        </section>

        <section>
          <h2>5. User Profiles and Content</h2>
          <p>
            You are responsible for all profile information, text, photos,
            videos, messages, and other content that you upload, send, or make
            available through the service. You must not upload or share content
            that is illegal, harmful, abusive, threatening, hateful, fraudulent,
            sexually exploitative, or that violates the rights of another person.
            We may remove content or restrict accounts that violate these Terms
            or our Service Rules.
          </p>
        </section>

        <section>
          <h2>6. Chat and Communication</h2>
          <p>
            TajneMysli allows users to communicate through chat features. Users may
            communicate with different types of profiles and participants,
            including other users and AI model profiles. Conversations on the
            platform are intended for entertainment, education, role-play,
            practice, and communication training. You should not rely on any
            chat message as professional advice or as a guaranteed statement of
            fact.
          </p>
        </section>

        <section>
          <h2>7. AI Model Profiles</h2>
          <p>
            Some profiles or chat participants may be powered by artificial
            intelligence or automated systems. AI model profiles may generate
            conversational responses for entertainment and educational purposes.
            AI-generated messages may be inaccurate, incomplete, fictional, or
            unsuitable for certain decisions. You are responsible for evaluating
            any information you receive and for using the service safely and
            responsibly.
          </p>
        </section>

        <section>
          <h2>8. Tokens and Virtual Features</h2>
          <p>
            Some features of the service require Tokens. Tokens are virtual
            units used only inside TajneMysli. Tokens have no cash value, are not
            legal currency, and cannot be exchanged for money unless explicitly
            required by applicable law or stated by the service. Tokens may be
            used to send chat messages, refresh certain limits, or access other
            game-like features made available in the application.
          </p>
        </section>

        <section>
          <h2>9. Starting Token Balance</h2>
          <p>
            New users receive 100 Tokens when they complete registration. This
            starting balance is provided to let users try the service and begin
            communicating. The amount of starting Tokens may be changed in the
            future for new users, promotions, tests, or updates to the service.
          </p>
        </section>

        <section>
          <h2>10. Chat Message Cost</h2>
          <p>
            Sending one chat message costs 20 Tokens. The Token cost may be
            shown inside the application before or during use of the chat
            feature. By sending a chat message, you agree that the required
            amount of Tokens may be deducted from your account balance.
          </p>
        </section>

        <section>
          <h2>11. Daily Match Limit</h2>
          <p>
            Each user may make matches with up to 20 users per day. This limit
            is intended to support fair use, reduce spam, and keep the service
            enjoyable for all users. The daily match limit may reset according
            to the service system time and may be adjusted or changed by the
            service from time to time.
          </p>
        </section>

        <section>
          <h2>12. Match Limit Upgrade</h2>
          <p>
            If a user wants to make more matches after reaching the daily match
            limit, the user may purchase a one-time match limit refresh for 50
            Tokens. This refresh can be purchased multiple times, subject to
            availability and service rules. Each refresh allows the user to
            continue matching according to the updated limit shown inside the
            application.
          </p>
        </section>

        <section>
          <h2>13. Payments and Purchases</h2>
          <p>
            If the service offers Token purchases or paid upgrades, prices,
            available packages, and payment methods will be displayed in the
            application or payment interface. You are responsible for reviewing
            the purchase details before confirming a payment. Paid features are
            provided for entertainment and educational use within the service.
          </p>
        </section>

        <section>
          <h2>14. Refunds</h2>
          <p>
            Unless otherwise required by applicable law, purchases of Tokens or
            virtual features may be final and non-refundable once delivered or
            used. If you believe there was a technical error, unauthorized
            purchase, or payment issue, please contact the service administrator
            so the issue can be reviewed.
          </p>
        </section>

        <section>
          <h2>15. Prohibited Conduct</h2>
          <p>
            You must not use the service for harassment, threats, hate speech,
            scams, spam, impersonation, illegal activity, exploitation, attempts
            to bypass payment systems, attempts to manipulate Tokens or limits,
            or any activity that may harm users, AI systems, the service, or its
            infrastructure. You must not attempt to access another user&apos;s
            account or interfere with the normal operation of the platform.
          </p>
        </section>

        <section>
          <h2>16. Safety and User Responsibility</h2>
          <p>
            You are responsible for your interactions on and outside the
            platform. If you communicate with another person, share personal
            information, or decide to meet someone outside the service, you do so
            at your own risk. Use caution, protect your personal information,
            and report suspicious or abusive behavior when possible.
          </p>
        </section>

        <section>
          <h2>17. Availability of the Service</h2>
          <p>
            We may update, modify, suspend, limit, or discontinue parts of the
            service at any time. We do not guarantee that the service will
            always be available, error-free, uninterrupted, or compatible with
            every device or browser. We may perform maintenance, testing, or
            technical changes that temporarily affect access to the service.
          </p>
        </section>

        <section>
          <h2>18. Account Suspension or Termination</h2>
          <p>
            We may suspend, restrict, or terminate accounts that violate these
            Terms of Service, the Service Rules, applicable laws, or that create
            risk for other users or the platform. We may also remove content,
            reduce access to features, or block certain activity if needed to
            protect the service.
          </p>
        </section>

        <section>
          <h2>19. Changes to These Terms</h2>
          <p>
            We may update these Terms of Service from time to time. The current
            version is shown on this page. When you register, the service may
            record the version of the Terms that you accepted and the server-side
            timestamp of acceptance. Continued use of the service after updates
            may require acceptance of the new version.
          </p>
        </section>

        <section>
          <h2>20. Contact</h2>
          <p>
            If you have questions about these Terms of Service, Tokens, account
            access, payments, or safety, please contact the service
            administrator using the contact method provided by the platform.
          </p>
        </section>
      </div>
    </div>
  );
}

export default TermsOfService;
